// removed by extract-text-webpack-plugin
module.exports = {"popoverZIndex":"19","popoverOZIndex":"21","mobile_car_container":"CatalogMobile__mobile_car_container___tavSY","mobile_responsive_img":"CatalogMobile__mobile_responsive_img___1bKST","release_date":"CatalogMobile__release_date___3VT3n","drop_down_category":"CatalogMobile__drop_down_category___3FYRa","right_float":"CatalogMobile__right_float___1XKj3"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Catalog/CatalogMobile.scss
 ** module id = 1340
 ** module chunks = 0
 **/